import {
  ComponentRendering,
  HtmlElementRendering,
  PlaceholdersData,
} from '@sitecore-jss/sitecore-jss-nextjs';

/**
 * Finds a component rendering by name within a placeholders data structure.
 *
 * @param placeholders - The placeholders data to search through.
 * @param componentName - The name of the component to find.
 * @returns The matching ComponentRendering, or null if not found.
 */
export const getComponentProps = (
  placeholders: PlaceholdersData | undefined,
  componentName: string
): ComponentRendering | null => {
  if (!placeholders) return null;

  return (
    Object.values(placeholders)
      .flat()
      .find(
        (el: ComponentRendering | HtmlElementRendering): el is ComponentRendering =>
          'componentName' in el && el.componentName === componentName
      ) ?? null
  );
};
